export default "__VITE_ASSET__Be$$JJcj__"